<template>
  <div>
    <v-footer
      color = #DCEDC8
    >
      <div class="tables">
        <table class="footer">
          <tr>
            <th v-on:click="servicios()" >SERVICIOS LG-LEGITRANS</th>
          </tr>
          <tr>
            <td>Gestión de residuos peligrosos y no <br>peligrosos.</td>
          </tr>
          <tr>
            <td>Autorización Plan Único de <br>Amianto, transporte y gestión.</td>
          </tr>
          <tr>
            <td>Vehículos de succión/chupona de <br>alta potencia. Limpieza de fosas</td>
          </tr>
          <tr>
            <td>Camión pulpo. Camión gancho.</td>
          </tr>
          <tr>
            <td>Contenedores.</td>
          </tr>
          <tr>
            <td>Transporte de mercancías, <br>peligrosas A.D.R.,  Sandach, etc.</td>
          </tr>
          <tr>
            <td>Absorbentes y kits de seguridad <br>industrial, barreras de contención, etc.</td>
          </tr>
          <tr>
            <td>Intervención rápida vertidos <br>accidentales.</td>
          </tr>
          <tr>
            <td>Desgasificación de depósitos.</td>
          </tr>
          <tr>
            <td>Laboratorio. Analíticas.</td>
          </tr>
        </table>

        <table class="footer">
          <tr>
            <th v-on:click="gestionAmbiental()">GESTIÓN AMBIENTAL</th>
          </tr>
          <tr>
            <td>Residuos industriales.</td>
          </tr>
          <tr>
            <td>Amianto (uralita).</td>
          </tr>
          <tr>
            <td>Lodos de depuradora.</td>
          </tr>
          <tr>
            <td>Absorbentes.</td>
          </tr>
          <tr>
            <td>Hidrocarburos.</td>
          </tr>
          <tr>
            <td>Fosa séptica.</td>
          </tr>
          <tr>
            <td>Tierras contaminadas.</td>
          </tr>
          <tr>
            <td>Envases plásticos, Metálicos, <br>Filtros de Aceite, Aire, <br>Anticongelante, Aceite, Baterías, <br>Aerosoles, Disolventes, <br>Pinturas, vidrio, Lunas, Madera.</td>
          </tr>
          <tr>
            <td>Sanitarios.</td>
          </tr>
          <tr>
            <td>Electrónicos.</td>
          </tr>
          <tr>
            <td>Más de 700 códigos LER de residuos…….</td>
          </tr>
        </table>

        <table class="footer">
          <tr>
            <th v-on:click="productos()">VEHICULOS/MEDIOS</th>
          </tr>
          <tr>
            <td>Cabezas tractoras.</td>
          </tr>
          <tr>
            <td>Semirremolque-Cisterna.</td>
          </tr>
          <tr>
            <td>Semirremolque-Cisterna-succión.</td>
          </tr>
          <tr>
            <td>Semirremolques-Bañera.</td>
          </tr>
          <tr>
            <td>Semirremolques-caja.</td>
          </tr>
          <tr>
            <td>Camión-Cisterna aceite.</td>
          </tr>
          <tr>
            <td>Camión-Pulpo.</td>
          </tr>
          <tr>
            <td>Contenedores 20 m3.</td>
          </tr>
        </table>

        <table class="footer">
          <tr>
            <th><a>CONTENEDORES</a></th>
          </tr>
          <tr>
            <td>Bidones ballesta.</td>
          </tr>
          <tr>
            <td>Bidones plástico.</td>
          </tr>
          <tr>
            <td>GRG.</td>
          </tr>
          <tr>
            <td>Jaulas.</td>
          </tr>
          <tr>
            <td>Pallox.</td>
          </tr>
          <tr>
            <td>BigBag.</td>
          </tr>
          <tr>
            <td>Sacas plástico.</td>
          </tr>
          <tr>
            <td>Botes toma de muestras</td>
          </tr>
        </table>

        <table class="footer">
          <tr>
            <th>CONTACTO</th>
          </tr>
          <tr>
            <td>Teléfono: 987 259 549</td>
          </tr>
          <tr>
            <td>Correo: administracion@lg-legitrans.com</td>
          </tr>
          <tr>
            <th>OFICINAS</th>
          </tr>
          <tr>
            <td><u>Sede Operativa y Oficinas Centrales:</u></td>
          </tr>
          <tr>
            <td>PG. IND. de León, PARC. M-68</td>
          </tr>
          <tr>
            <td>24231 (Onzonilla) León</td>
          </tr>
          <tr>
            <td><u>Consejo de Administración:</u></td>
          </tr>
          <tr>
            <td>CL Guzmán el Bueno 133, EDIF. Britania</td>
          </tr>
          <tr>
            <td>28003 Madrid</td>
          </tr>
        </table>
      </div>
      <img src="../assets/footer.jpg" class="footerImg">
    </v-footer>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    msg: String
  }
}
</script>

<style scoped>
v-footer {
  left: 0;
  bottom: 0;
  width: 100%;
}

.footer {
  height: 100%;
  margin: auto;
  padding: 25px;
  display: inline-table;
  
}

.footerImg{
  width: 33%;
  margin: auto;
  padding-bottom:25px ;
}

th {
  padding: 10px;
  text-align: center;
}

td {
  padding-top: 10px;
  text-align: center;
}
.tables {
  width: fit-content;
  margin: auto;

}

</style>